export const comments_5618948 = {"data":{"data":[],"links":{}}}